import mongodb from './mongodb';
import elasticsearch from './elasticsearch';

export default { mongodb, elasticsearch };
